import Vue from 'vue';
import Vuex from 'vuex';
import appApiClass from '@/api/AppApi.ts';

const appApi = new appApiClass();

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    device: '',
  },
  getters: {
    deviceName(state) {
      return state.device;
    },
  },
  mutations: {
    receiveDeviceName(state, payload) {
      state.device = payload;
    },
  },
  actions: {
    getDeviceName({commit}) {
      const u = navigator.userAgent;
      let device = '';
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        device = 'Android';
      } else if (u.indexOf('iPhone') > -1) {
        device = 'iPhone';
      } else if (u.indexOf('Windows Phone') > -1) {
        device = 'WindowsPhone';
      }
      commit('receiveDeviceName', device);
    },
    async getWXConfigSign({commit}, {baseUrl, signUrl}) {
      const response: any = await appApi.wxConfigSig(baseUrl, signUrl);
      if (response && response.data) {
        return response.data;
      }
    },
  },
});
